import Prompt from "./Prompt"

const PromptList = ({prompts, isSelected, getSelected, setSelected}) => {
    return (
        <ul className="prompt-list">
            {prompts.map(prompt => (
                <li key={prompt.id}>
                    <Prompt {...prompt}
                        isSelected={isSelected}
                        getSelected={getSelected}
                        setSelected={setSelected}
                    />
                </li>)
            )}
        </ul>
    )
}

export default PromptList